jQuery(($) => {

    $('.a-product-variation-button').click(function () {
        var items = $(this).closest('.m-product-variation-buttons');

        items.find($('.a-product-variation-button')).removeClass('a-product-variation-button--active');

        if ($(this).hasClass('a-product-variation-button--active')) {
            $(this).removeClass('a-product-variation-button--active');
        } else {
            $(this).addClass('a-product-variation-button--active');
        }
    });
});